import type { FetchyeResponse } from 'fetchye';
import type { FetchyeAmexData } from '@americanexpress/fetchye-amex';
import { useOneDataFetchye } from '@americanexpress/fetchye-amex';

import type { Refresh } from '../../../components/types';
import useSplunkLogger from './useSplunkLogger';
import useOnce from '../useOnce';

export type Options<Res, Req> = Parameters<typeof useOneDataFetchye<Res, Req>>[1];
const useOneDataFetchyeWithLogging = <Req extends object, Res extends object = object>(
  apiName: string,
  refresh: Refresh,
  options?: Options<Res, Req>):
  FetchyeResponse<FetchyeAmexData<Res>> => {
  const log = useSplunkLogger();
  const fetchyeReturn = useOneDataFetchye<Res, Req>(apiName, options);

  const { data: response, error, isLoading } = fetchyeReturn;

  useOnce(!isLoading && (error || response), () => {
    log(Boolean(response?.ok), {
      apiName,
      error: error || null,
      refresh,
      message: `${apiName} ${response?.ok ? 'success' : 'failure'}`,
      responseCode: response?.status || null,
      correlationId: response?.correlationId || null,
      requestBody: options?.body || {},
    });
  });

  return fetchyeReturn;
};

export default useOneDataFetchyeWithLogging;
